export const OnErrorScrollPoint = ({ name }: { name: string }) => {
	return <input type='hidden' name={name} />;
};
